import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Preview from "./pages/menu/Preview";

function App() {
  return (
    <Routes>
      <Route path="/menu/preview" element={<Preview />} />
      <Route path="/restaurant/menu/:menuId" element={<Preview mode="menuId" />} />
      <Route path="*" element={<Navigate to="/menu/preview" replace />} />
    </Routes>
  );
}

export default App;
